<template>
  <!-- 分店訂單列表 -->
  <section class="content">
    <div class="row center-block">
      <div class="col-xs-12 p-x-0 m-b-10">
        <button @click="$router.go(-1)" class="btn btn-default">
          返回抽成列表
        </button>
      </div>
      <div class="col-md-12">
        <div class="box">
          <div class="box-header">
            <!-- 訂單篩選 -->
            <div class="form-inline">
              <div class="flex">
                <select
                  class="form-control h-38"
                  style="max-width: 140px"
                >
                  <option :value="1">下訂時間</option>
                </select>
                <!-- 下訂時間 -->
                <div class="h-38 m-l-5 w-120">
                  <date-time-picker
                    :date="startDate"
                    :enabled="isLoading"
                    :option="dateoption"
                    :limit="dateLimit">
                  </date-time-picker>
                </div>
                <div class="h-38 m-l-5 w-120">
                  <date-time-picker
                    :date="endDate"
                    :enabled="isLoading"
                    :option="dateoption"
                    :limit="dateLimit">
                  </date-time-picker>
                </div>
                <select
                  v-model="filterType"
                  class="form-control h-38 m-l-15"
                  style="max-width: 140px"
                >
                  <option :value="1">訂單編號</option>
                  <option :value="2">訂單狀態</option>
                  <option :value="3">取餐類型</option>
                  <option :value="4">付款類型</option>
                </select>
                <div class="input-group h-38">
                  <!-- 訂單編號 -->
                  <input
                    v-if="filterType === 1"
                    class="form-control h-38"
                    v-model="orderSN"
                    type="text"
                    style="min-width: 170px;"
                  >
                  <!-- 訂單狀態 -->
                  <select
                    v-if="filterType === 2"
                    :disabled="isLoading"
                    class="form-control h-38"
                    v-model="statusSelect"
                    style="min-width: 170px;"
                  >
                    <option
                      v-for="status in statusList"
                      :key="status.value"
                      :value="status.value"
                    >
                      {{ status.label }}
                    </option>
                  </select>
                  <!-- 取餐類型 -->
                  <select
                    v-if="filterType === 3"
                    :disabled="isLoading"
                    class="form-control h-38"
                    v-model="deTypeSelect"
                    style="min-width: 170px;"
                  >
                    <option
                      v-for="(type) in deliveryTypeList"
                      :key="type.value"
                      :value="type.value"
                    >
                      {{ type.label }}
                    </option>
                  </select>
                  <!-- 付款類型 -->
                  <select
                    v-if="filterType === 4"
                    class="form-control h-38"
                    v-model="trTypeSelect"
                    style="min-width: 170px;"
                  >
                    <option
                      v-for="trade in getTradeType"
                      :key="trade.value"
                      :value="trade.value"
                    >
                      {{ trade.label }}
                    </option>
                  </select>
                  <!-- 搜尋鈕 -->
                  <span class="input-group-addon c-pointer" @click="setQuery"><i class="fa fa-search"></i></span>
                </div>
              </div>
            </div>
            <div class="row form-inline m-t-10 flex align-end">
              <div class="col-sm-6">
                <h5>
                  <span class="text-red">＊</span>
                  門市資訊服務費抽成原金額: ${{ totalCommissionMoney }}
                </h5>
                <h5>
                  <span class="text-red">＊</span>
                  抽成金額為訂單實付金額 * 抽成 %；採四捨五入計算
                </h5>
              </div>
              <div class="col-sm-6 m-b-10 text-right">
                <button
                  class="btn btn-default p-a-10"
                  disabled
                  @click="exportFile"
                >
                  <i class="fa fa-download">下載報表</i>
                  <Clip
                    class="cliploading"
                    :loading="isDownloading"
                    :color="'#528BB8'"
                    :size="'16px'"
                  />
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                  <thead>
                    <tr role="row">
                      <th class="vertical-m" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">#</th>
                      <th class="vertical-m" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">訂單編號</th>
                      <th class="vertical-m" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">品牌 (ID)</th>
                      <th class="vertical-m" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">分店 (ID)</th>
                      <th class="vertical-m" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">取餐類型</th>
                      <th class="vertical-m" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">付款類型</th>
                      <th class="vertical-m" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">訂單來源</th>
                      <th class="vertical-m" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">訂單狀態</th>
                      <th class="vertical-m" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">下訂時間</th>
                      <th class="vertical-m" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">實付金額</th>
                      <th class="vertical-m" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">抽成％</th>
                      <th class="vertical-m" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">已完成訂單資訊服務費抽成金額</th>
                      <th class="vertical-m" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">已作廢訂單資訊服務費抽成金額</th>
                      <th class="vertical-m" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">
                        資訊服務費抽成金額
                        <span data-toggle="tooltip" class="tip-icon" data-placement="bottom" title="已完成+已作廢訂單資訊服務費抽成金額">
                          <i class="fa fa-question-circle" aria-hidden="true"></i>
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="isLoading">
                    <tr>
                      <td colspan="14" class="text-center">資料讀取中......</td>
                    </tr>
                  </tbody>
                  <tbody v-else-if="list.length === 0" >
                    <tr style="background-color: white">
                      <td rowspan="1" colspan="14" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                        <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                        <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr v-for="(row, index) in list" :key="index" class="even" role="row">
                      <td class="sorting_1">{{ index + 1 }}</td>
                      <td>
                        <router-link :to="{ path: '/orderInfo/' + row.order_id }" target="_blank">
                          {{ row.order_sn }}
                        </router-link>
                      </td>
                      <td>{{ row.brand_name }}({{ row.brand_id }})</td>
                      <td>{{ row.store_name }}({{ row.store_id }})</td>
                      <td>{{ row.delivery_type | deliveryName }}</td>
                      <td>{{ row.trade_type | tradeName }}</td>
                      <td>
                        <!-- 訂單來源 -->
                        <span class="text-12 text-w-600 label-default" style="padding: 0px 3px" v-if="row.src_type === 1 || row.src_type === 3">P</span>
                        <span class="text-12 text-w-600 label-warning" style="padding: 0px 3px" v-else>D</span>
                        <!-- 訂單瀏覽器來源 -->
                        <span class="text-12 text-w-600 label-default" style="padding: 0px 3px" v-if="row.sub_src_type === 1">W</span>
                        <span class="text-12 text-w-600 label-success" style="padding: 0px 3px" v-else-if="row.sub_src_type === 2">L</span>
                        <span class="text-12 text-w-600 label-primary" style="padding: 0px 3px" v-else-if="row.sub_src_type === 3">M</span>
                        <span class="text-12 text-w-600 label-success" style="padding: 0px 3px" v-else-if="row.sub_src_type === 4">LI</span>
                        <span class="text-12 text-w-600 label-danger" style="padding: 0px 3px;" v-else-if="row.sub_src_type === 5">J</span>
                      </td>
                      <td>{{ row.order_status | orderStatusName }}</td>
                      <td>{{ row.order_time }}</td>
                      <td>$ {{ row.total_paid_money }}</td>
                      <td>{{ row.commission_ratio }}%</td>
                      <td>$ {{ row.total_finish_commission_money }}</td>
                      <td>$ {{ row.total_void_commission_money }}</td>
                      <td>$ {{ row.total_commission_money }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <paginate
                :pageAmount="pageAmount"
                :total="total"
                :isActive="isActive"
                :groupAmount="groupAmount"
                :clickPage="clickPage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import Clip from 'vue-spinner/src/ClipLoader.vue'
import moment from 'moment'

export default {
  name: 'CommissionStore',
  components: {
    'date-time-picker': datetimePicker,
    'Clip': Clip
  },
  data () {
    return {
      brandName: '',
      storeName: '',
      total: 0,
      count: 10,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      isLoading: false,
      list: [],
      totalCommissionMoney: 0, // 抽成總金額
      first: true, // 首次進入 (避免 API 呼叫兩次)
      // 下載排程
      // retry: 0,
      // retryTimer: null,
      // retryFrequency: 0,
      isDownloading: false,
      // 篩選
      query: {}, // 搜尋條件
      filterType: 1,
      orderSN: '',
      startDate: {
        time: moment().format('YYYY-MM-DD')
      },
      endDate: {
        time: moment().format('YYYY-MM-DD')
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '24px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      dateLimit: [
        {
          type: 'fromto',
          to: moment().add(1, 'days').format('YYYY-MM-DD')
        }
      ],
      deTypeSelect: 999,
      deliveryTypeList: [
        {label: '== 取餐類型 ==', value: 999},
        {label: '自取', value: 1},
        {label: '外送', value: 3},
        {label: '內用', value: 2},
        {label: '外帶', value: 4},
        {label: '內用-桌邊掃碼', value: 21}
      ],
      statusSelect: 999,
      statusList: [
        {label: '== 訂單狀態 ==', value: 999},
        {label: '已完成', value: 130},
        {label: '已作廢', value: 140}
      ],
      trTypeSelect: 999
    }
  },
  computed: {
    ...mapGetters(['getTradeType']),
    pageAmount () {
      return Math.ceil(this.total / this.count)
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getFile () {
      return this.$parent.getFile
    }
  },
  created () {
    this.setDefault()
    this.setQuery()
    this.getStoreInfo()
  },
  methods: {
    setDefault () {
      // 設定預設時間 (注意結束時間不可超過現在時間)
      if (this.$route.query && this.$route.query.year && this.$route.query.type && this.$route.query.period) {
        let type = ''
        let month = Number(this.$route.query.period)
        if (this.$route.query.type === 'quarterly') {
          // 季
          month = month * 3
          type = 'quarter'
        } else {
          // 月
          type = 'month'
        }
        const time = `${this.$route.query.year}-${month.toString().padStart(2, '0')}-01`
        this.startDate.time = moment(time).startOf(type).format('YYYY-MM-DD')
        this.endDate.time = moment().isBefore(moment(time).endOf(type)) ? moment().format('YYYY-MM-DD') : moment(time).endOf(type).format('YYYY-MM-DD')
      }
    },
    clickPage (index) {
      this.tableIndex = index
      this.getList()
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    setQuery () {
      // 設定搜尋條件
      this.query = {
        start_date: moment(this.startDate.time).format('YYYYMMDD'),
        end_date: moment(this.endDate.time).format('YYYYMMDD')
      }
      if (this.filterType === 1 && this.orderSN.trim()) {
        this.query.order_sn = this.orderSN.trim()
      } else if (this.filterType === 2 && this.statusSelect !== 999) {
        this.query.order_status = this.statusSelect
      } else if (this.filterType === 3 && this.deTypeSelect !== 999) {
        this.query.delivery_type = this.deTypeSelect
      } else if (this.filterType === 4 && this.trTypeSelect !== 999) {
        this.query.trade_type = this.trTypeSelect
      }
      this.clickPage(1)
    },
    getList () {
      // 取得列表
      this.isLoading = true
      let url = 'orderCommission/order/list?page=' + this.tableIndex + '&size=' + this.count + '&store_id=' + this.$route.params.store_id
      Object.keys(this.query).forEach(key => {
        url = url + `&${key}=${this.query[key]}`
      })
      this.getDataH('get', url, null, (response) => {
        this.list = response.data.list
        this.totalCommissionMoney = response.data.total_commission_money
        this.total = response.data.total
        this.isLoading = false
        if (this.first) {
          this.first = false
        }
      })
    },
    getStoreInfo () {
      // 取得品牌與門市名稱
      const url = 'store/' + this.$route.params.store_id + '/info'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.brandName = response.data.info.brand_name
          this.storeName = response.data.info.name
        }
      })
    },
    exportFile () {
      // 下載報表
      this.isDownloading = true
      let url = 'orderCommission/order/listSheets?store_id=' + this.$route.params.store_id
      Object.keys(this.query).forEach(key => {
        url = url + `&${key}=${this.query[key]}`
      })
      this.getFile('get', url, null, (response) => {
        this.isDownloading = false
        let blob = new Blob([response.data], {type: 'application/vnd.ms-excel'})
        let objectUrl = URL.createObjectURL(blob)
        let a = document.createElement('a')
        const name = `${this.brandName}_${this.storeName}_資訊服務費抽成對帳分店明細表_${this.startDate.time}~${this.endDate.time}.xlsx`

        a.download = name
        a.href = objectUrl
        document.body.appendChild(a)
        a.click()
      })
    },
    exportScheduleFile () {
      // 下載報表
      this.isDownloading = true
      let url = 'orderCommission/order/listSheetsSchedule?store_id=' + this.$route.params.store_id
      Object.keys(this.query).forEach(key => {
        url = url + `&${key}=${this.query[key]}`
      })
      if (this.retry === 1) {
        url = url + '&retry=1'
      }
      this.getDataH('get', url, null, (response) => {
        if (response.data.sche_info.status === 3) {
          this.isDownloading = false
          this.retry = 0
          let a = document.createElement('a')
          a.href = response.data.sche_info.file_url
          document.body.appendChild(a)
          a.click()
          clearTimeout(this.retryTimer)
          this.retryFrequency = 0
        } else if (response.data.sche_info.status === 9) {
          this.isDownloading = false
          if (this.retryFrequency > 3) {
            alert('請聯絡客服或等24小時候再試')
            return false
          }
          var yes = confirm('輸出未完成，請聯絡客服或再試一次')
          if (yes) {
            this.retryFrequency++
          }
          clearTimeout(this.retryTimer)
        } else {
          this.retry = 1
          this.retryTimer = setTimeout(this.exportFile, 6000)
        }
      })
    }
  },
  watch: {
    'startDate.time' () {
      if (!this.first) {
        this.setQuery()
      }
    },
    'endDate.time' () {
      if (!this.first) {
        this.setQuery()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CommissionStore.vue?2f374c72